var map = {
	"./ArticlesofAssociationorAnnualReturn.png": "8aec",
	"./FormofIncorporationNNC.png": "19b7",
	"./PassportHome.png": "4ff7",
	"./taxcertificatehongkong.png": "c4da"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e334";